import { styled } from '@mui/system';

export const LogoWrapper = styled('div')({
	position: 'absolute',
	bottom: 0,
	right: '24px',
	zIndex: 1,
});
